import apiSkobo from "@/helpers/api/apiSkobo";

export const leftMenu_actions = {
  async loadLeftMenu() {
    if (this.leftMenuState.length === 0) {
      this.reloadLeftMenu();
    }
  },

  async reloadLeftMenu() {
    const response = await apiSkobo.get("/navigation/menu");
    this.leftMenuState = response.data.values;
  }
};

export const leftMenu_getters = {
  leftMenu: state => state.leftMenuState,
  leftShortcuts: () => []
};

export const leftMenu_state = {
  leftMenuState: []
};
